import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ImportsModule } from '../../../shared/imports.module';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { PerfilStore } from '../../store/perfil.store';
import { Usuario } from '../../models';

@Component({
  selector: 'app-menus',
  standalone: true,
  imports: [ImportsModule],
  templateUrl: './menus.component.html',
  styleUrl: './menus.component.scss',
})
export class MenusComponent implements OnInit, OnDestroy {
  $onDestroy: Subject<void> = new Subject<void>();
  @Input() isCollapsed = false;
  user : Usuario | null = null;
  constructor(
    private router: Router,
    private sessionStore: PerfilStore,
  ) {
  }
  /**
   * @description Menu Component Integracion del Menu en la plataforma
   * @return {void}
   */


  /**
 * @description Obtiene la informacion de los Menus desde el Store y los asigna a la variable menus
 * @return {void}
 */

  async ngOnInit() {
   this.getUser();
  }

  getUser(){
    this.sessionStore
      .getPerfil()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((user) => {
        this.user = user;
      });
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

    toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }

    goTo( item : string ) {
    this.router.navigate([item]);
  }
}
